import Repository from './Repository'
import { API_BASE_PATH } from './ApiPath'

const ADMIN = API_BASE_PATH.ADMIN

export default {
  getTeams(queries: any) {
    return Repository.get(`${ADMIN}/team`, { params: queries })
  },
  getTeam(team_id: number) {
    return Repository.get(`${ADMIN}/team/${team_id}`)
  },
  postTeam(data: any) {
    return Repository.post(`${ADMIN}/team`, data)
  },
  updateTeam(data: any) {
    return Repository.put(`${ADMIN}/team`, data)
  },
  deleteTeam(params: any) {
    return Repository.delete(`${ADMIN}/team`, { data: params })
  }
}